import React, { useEffect, useState } from 'react';
import { WeatherData } from '../../types';
import { fetchAirstripWeather } from '../../services/weather';

const PlanningWeatherNode: React.FC<{ code: string }> = ({ code }) => {
  const [data, setData] = useState<WeatherData | null>(null);

  useEffect(() => {
    fetchAirstripWeather(code).then(setData);
  }, [code]);

  if (!data) return <div className="w-8 h-4 bg-slate-100 animate-pulse rounded"></div>;

  return (
    <div className="flex items-center gap-2 group/weather cursor-help relative">
      <span className={`w-1.5 h-1.5 rounded-full ${data.condition === 'VFR' ? 'bg-emerald-500' : data.condition === 'MVFR' ? 'bg-amber-500' : 'bg-rose-500'}`}></span>
      <span className="text-[9px] font-black text-slate-500 font-mono">{data.temp}°C {data.wind}</span>
      <div className="absolute bottom-full mb-2 left-0 bg-slate-800 text-white p-3 rounded-xl shadow-2xl scale-0 group-hover/weather:scale-100 transition-all origin-bottom-left z-50 min-w-[140px]">
        <p className="text-[10px] font-black uppercase tracking-widest text-indigo-400 mb-1">{code} METAR</p>
        <p className="text-[9px] font-bold text-white">{data.description}</p>
      </div>
    </div>
  );
};

export default PlanningWeatherNode;
